import React, { forwardRef, useState } from 'react'
// import { useAppSelector } from '../../app/hooks'
// import TimesheetRow from './TimesheetRow'
import TimesheetTableSectionOne from './TimesheetTableSectionOne'
import TimesheetTableSectionThree from './TimesheetTableSectionThree'
import TimesheetTableSectionTwo from './TimesheetTableSectionTwo'

const TimesheetSections = forwardRef((props, ref) => {
    // const { timeEntriesList } = useAppSelector((state) => state.timesheet);
    return (
        <>
            <TimesheetTableSectionOne />
            <TimesheetTableSectionTwo ref={ref}/>
            <TimesheetTableSectionThree />
        </>
    )
})

export default TimesheetSections